<template>
    <CreateEntityForm
        :form-id="formId"
        :fields="fieldMeta"
    />
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { CustomProperty } from '@evidentid/tprm-portal-lib/models/dashboard';

    import { RequirementLabels } from '@/components/migrated-compliance-section/migratedCompliance';
    import { useContractExtractionStore } from '@/modules/contract-extraction/store';
    import { FieldMeta } from '@/modules/dynamic-form/models/FieldMeta.model';
    import { FieldPath } from '@/modules/dynamic-form/models/FieldPath.model';
    import { useDynamicFormStore } from '@/modules/dynamic-form/store';

    import {
        buildContractExtractionEntityFieldMeta,
        buildContractExtractionEntityFieldValidators,
    } from '../../utils/buildContractExtractionEntityFieldMeta';
    import { seedEntityFormValuesFromEntityInfo } from '../../utils/mockEntityAiFields';

    import CreateEntityForm from './sub-components/CreateEntityForm.vue';

    export default defineComponent({
        name: 'CreateEntity',
        components: { CreateEntityForm },
        props: {
            rpName: {
                type: String as PropType<string>,
                required: true,
            },
            contractExtractionId: {
                type: String as PropType<string>,
                required: true,
            },
            customProperties: {
                type: Array as PropType<CustomProperty[]>,
                default: (): CustomProperty[] => [],
            },
            requirementTypes: {
                type: Array as PropType<string[]>,
                default: (): string[] => [],
            },
            requirementDefinitions: {
                type: Object as PropType<RequirementLabels>,
                default: (): RequirementLabels => ({}),
            },
        },
        data() {
            return {
                fieldMeta: [] as FieldMeta[],
            };
        },
        computed: {
            formId(): string {
                return `contract-extraction-entity-${this.contractExtractionId}`;
            },
        },
        created() {
            const fields = buildContractExtractionEntityFieldMeta(
                this.customProperties,
                this.requirementTypes,
                this.requirementDefinitions,
            );
            this.fieldMeta = fields;

            const entityInfo = useContractExtractionStore()
                .criteria[(this as any).rpName]?.[(this as any).contractExtractionId]?.entityInfo ?? null;

            const seededValues = seedEntityFormValuesFromEntityInfo(fields, entityInfo);

            const fieldsMeta = fields.reduce(
                (acc, field) => {
                    acc[field.path] = field;
                    return acc;
                },
                {} as Record<FieldPath, FieldMeta>,
            );

            const fieldValidators = buildContractExtractionEntityFieldValidators(fields);

            useDynamicFormStore().initializeForm({
                formId: this.formId,
                values: seededValues,
                fieldsMeta,
                fieldValidators,
                customControls: {},
                customMessages: {} as any,
            });
        },
        beforeUnmount() {
            useDynamicFormStore().cleanupForm({ formId: this.formId });
        },
    });
</script>
